export { getStaticProps } from '@ui/utils/getStaticPropsWithFooter';
export { UseLcro as default } from '@ui/views/UseLcroPage';
